<template>
  <Modal
    :title="titleLabel"
    width="1200"
    name="SelectAvailableDatesModal"
    actions
  >
    <template v-slot:body>
      <div class="date-selection--header">
        <SelectAvailableDatesNavigation
          @goToCurrentWeek="goToCurrentWeek"
          @prevWeek="prevWeek"
          @nextWeek="nextWeek"
          :currentWeekStart="currentWeekStart"
          :currentWeekEnd="currentWeekEnd" />
      </div>

      <SelectAvailableDatesList
        v-show="!loadingAvailableDates"
        @setSelectedDateAndTime="setSelectedDateAndTime"
        :newAppointmentDateInfo="newAppointmentDateInfo"
        :loadingAvailableDates="loadingAvailableDates"
        :availableDates="availableDates"
        :currentWeekStart="currentWeekStart"
        :currentWeekEnd="currentWeekEnd" />

      <Loading v-if="loadingAvailableDates" />
    </template>
    <template v-slot:actions>
      <SelectAvailableDatesActions
        @submitNewDate="submitNewDate"
        :newAppointmentDateInfo="newAppointmentDateInfo" />
    </template>
  </Modal>
</template>

<script>
// store
import { mapActions, mapGetters } from 'vuex'

// third-party
import moment from 'moment-timezone'

// utils
import { normalizeAvailableSlots } from './normalizeAvailableSlots'

// api
import { api } from '../../../services'

// components
import Modal from '../../../components/app/Modal.vue'
import Loading from '../../../components/app/Loading.vue'
import SelectAvailableDatesList from './fragments/SelectAvailableDatesList.vue'
import SelectAvailableDatesActions from './fragments/SelectAvailableDatesActions.vue'
import SelectAvailableDatesNavigation from './fragments/SelectAvailableDatesNavigation.vue'

export default {
  name: 'howAvailableDates',

  props: {
    timezone: {
      type: String,
      required: true,
    },
  },

  components: {
    Modal,
    Loading,
    SelectAvailableDatesList,
    SelectAvailableDatesActions,
    SelectAvailableDatesNavigation,
  },

  methods: {
    ...mapActions(['closeModal']),

    initWeek() {
      const tz = moment.tz.guess()
      const startLocal = moment.tz(moment(), tz).startOf('isoWeek')
      const endLocal = startLocal.clone().add(6, 'days')

      this.currentWeekStart = startLocal.clone().utc().format('YYYY-MM-DD')
      this.currentWeekEnd = endLocal.clone().utc().format('YYYY-MM-DD')
    },

    async fetchAvailableDates(startDate, endDate) {
      this.availableDates = []
      this.loadingAvailableDates = true

      try {
        const url = `${this.AVAILABLE_HOURS_URL}?appointmentId=${this.appointmentId}&startDate=${startDate}T00:00:00Z&endDate=${endDate}T23:59:59Z`
        const { data } = await api.get(url)
        this.availableDates = normalizeAvailableSlots(data, this.timezone)
      } catch (error) {
        console.error(error?.message)
      } finally {
        this.loadingAvailableDates = false
      }
    },

    nextWeek() {
      const nextStart = moment.utc(this.currentWeekStart).add(7, 'days').format('YYYY-MM-DD')
      const nextEnd = moment.utc(nextStart).add(6, 'days').format('YYYY-MM-DD')
      this.currentWeekStart = nextStart
      this.currentWeekEnd = nextEnd
      this.fetchAvailableDates(nextStart, nextEnd)
    },

    prevWeek() {
      const prevStart = moment.utc(this.currentWeekStart).subtract(7, 'days').format('YYYY-MM-DD')
      const prevEnd = moment.utc(prevStart).add(6, 'days').format('YYYY-MM-DD')
      this.currentWeekStart = prevStart
      this.currentWeekEnd = prevEnd
      this.fetchAvailableDates(prevStart, prevEnd)
    },

    goToCurrentWeek() {
      this.initWeek()
      this.fetchAvailableDates(this.currentWeekStart, this.currentWeekEnd)
    },

    setSelectedDateAndTime(timeItemData) {
      this.newAppointmentDateInfo = timeItemData
    },

    submitNewDate() {
      this.$emit('setNewAppointmentDateInfo', this.newAppointmentDateInfo)
      this.closeModal('SelectAvailableDatesModal')
    },
  },

  computed: {
    ...mapGetters(['activeModal']),

    appointmentId() {
      return this.$route.params.id
    },
  },

  watch: {
    activeModal(modalName) {
      if (modalName === 'SelectAvailableDatesModal') {
        this.newAppointmentDateInfo = null
        this.initWeek()
        this.fetchAvailableDates(this.currentWeekStart, this.currentWeekEnd)
      }
    },
  },

  data() {
    return {
      AVAILABLE_HOURS_URL: '/web/open/appointment/availableHoursToConfirm',

      newAppointmentDateInfo: null,
      availableDates: [],
      loadingAvailableDates: false,

      // navegação semanal
      currentWeekStart: null,
      currentWeekEnd: null,

      titleLabel: this.$t('appointment.confirmAppointment.availableDates.title'),
      descriptionLabel: this.$t('appointment.confirmAppointment.availableDates.description'),
    }
  },
}
</script>
